module.exports = function () { /* empty */ };



//////////////////
// WEBPACK FOOTER
// /Users/balazskaxd/dev/rkk/rkk-webapp/~/core-js/library/modules/_add-to-unscopables.js
// module id = 620
// module chunks = 20